import React from "react";

class CheckboxContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          {this.props.modules.map(modulex => (
            <div className="col-md-3" style={{marginBottom:"30px"}}>
              <h5 key={modulex.id}>{modulex.name} {/*<input type="checkbox" className="float-right" onChange={(e) => this.props.handleChangeAll(e, this.props.modules)}/>*/}</h5>

              {modulex.section_accion_apps.map(item => (
                <div>
                  <label key={item.id}>
                
                    <input
                      style={{marginRight:"10px"}}
                      type="checkbox"
                      value={item.id}
                      checked={this.props.checkedItems.get(item.id.toString())}
                      onChange={this.props.handleChangeAccions}
                    />  {item.name}
                  </label>
                </div>
              ))}
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default CheckboxContainer;
